import * as documentationContractStatuses from 'constants/enums/documentationContractStatuses'

export default {
  [documentationContractStatuses.NEW]: 'Nová',
  [documentationContractStatuses.CLIENT]: 'Na klienta',
  [documentationContractStatuses.APPROVAL]: 'Ke schválení',
  [documentationContractStatuses.REALIZED]: 'Realizovaná',
  [documentationContractStatuses.NOT_REALIZED]: 'Nerealizovaná',
}
